export default __webpack_public_path__ + "static/HTH-homepage-tablet-77856df8fa79cb3389e0a38992d4497c.jpg";